import { render, staticRenderFns } from "./Snacks.vue?vue&type=template&id=31914a1f&scoped=true&"
import script from "./Snacks.vue?vue&type=script&lang=js&"
export * from "./Snacks.vue?vue&type=script&lang=js&"
import style0 from "./Snacks.vue?vue&type=style&index=0&id=31914a1f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31914a1f",
  null
  
)

export default component.exports